import React from 'react';
import { DatePicker, Button, Space } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import dayjs, { Dayjs } from 'dayjs';
import { ViewMode } from './ViewToggle';
import './DateNavigator.css';

interface DateNavigatorProps {
  value: Dayjs;
  onChange: (date: Dayjs) => void;
  viewMode: ViewMode;
}

export const DateNavigator: React.FC<DateNavigatorProps> = ({ value, onChange, viewMode }) => {
  const handlePrevious = () => {
    switch (viewMode) {
      case 'cards':
      case 'day':
        onChange(value.subtract(1, 'day'));
        break;
      case 'week':
        onChange(value.subtract(1, 'week'));
        break;
      case 'month':
        onChange(value.subtract(1, 'month'));
        break;
    }
  };

  const handleNext = () => {
    switch (viewMode) {
      case 'cards':
      case 'day':
        onChange(value.add(1, 'day'));
        break;
      case 'week':
        onChange(value.add(1, 'week'));
        break;
      case 'month':
        onChange(value.add(1, 'month'));
        break;
    }
  };

  const handleToday = () => {
    onChange(dayjs());
  };

  const getDateLabel = () => {
    switch (viewMode) {
      case 'cards':
      case 'day':
        return value.format('MMMM D, YYYY (dddd)');
      case 'week':
        const weekStart = value.startOf('week');
        const weekEnd = value.endOf('week');
        return `${weekStart.format('MMM D')} - ${weekEnd.format('MMM D, YYYY')}`;
      case 'month':
        return value.format('MMMM YYYY');
      default:
        return value.format('MMMM D, YYYY');
    }
  };

  return (
    <Space className="date-navigator">
      <Button
        size="large"
        onClick={handleToday}
      >
        Today
      </Button>
      <Space.Compact>
        <Button
          size="large"
          icon={<LeftOutlined />}
          onClick={handlePrevious}
        />
        <DatePicker
          value={value}
          onChange={(date) => date && onChange(date)}
          format="MMM DD, YYYY"
          style={{ width: '100%', minWidth: 140, maxWidth: 200 }}
          size="large"
          renderExtraFooter={() => (
            <div style={{ textAlign: 'center', padding: '8px' }}>
              {getDateLabel()}
            </div>
          )}
        />
        <Button
          size="large"
          icon={<RightOutlined />}
          onClick={handleNext}
        />
      </Space.Compact>
    </Space>
  );
};
